import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {MapsCommonService} from "../../services/mapsCommon.service";

export class FulfillmentMapComponent implements IController {
  steps: any;
  attempts: any;
  serviceAreas: any;

  private map: any;
  private isReady: boolean;
  private taskMarkers: any;
  private taskEvents: any;
  private filters: any;
  private mapServiceAreas: any;


  constructor(private mapsCommonService: MapsCommonService) {
  }

  $onInit() {
    this.filters = {
      serviceAreas: true
    };

    this.map = {
      isReady: false,
      center: this.mapsCommonService.getSiteLocation(),
      zoom: 14,
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        scaleControl: true,
        mapTypeControl: false
      },
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.isReady = true;
            google.maps.event.trigger(map, 'resize')
            this.centerMap();
          }
        }
      },
      bounds: {},
      control: {}
    };

    if (this.steps?.length) {
      this.taskMarkers = this.mapsCommonService.stepsToMarkers(this.steps);
    }
    if(this.attempts?.length){
      this.taskMarkers = this.mapsCommonService.attemptsToMarkers(this.attempts);
    }
    this.taskEvents = {
      mouseover: (marker, event, model, args) => {
      },
      mouseout: (marker, event, model, args) => {
      }
    };

    this._setMapServiceAreas(this.serviceAreas);

  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.steps && !changes.steps.isFirstChange()) {
      this.$onInit()
    }

    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this._setMapServiceAreas(this.serviceAreas);
    }
  }

  centerMap() {
    const markers = this.googleMapMarkers();
    this.mapsCommonService.centerMapByBounds(this.map, markers);
  }

  onToggleServiceAreas(isEnabled) {
    this._setMapServiceAreas(this.serviceAreas);
  }

  private googleMapMarkers() {
    let markers = [];
    _.forEach(this.taskMarkers, taskMarker => {
      const fakeMarker = new google.maps.MVCObject();
      fakeMarker.set('coords', {'latitude': taskMarker.location.lat, 'longitude': taskMarker.location.lng});
      markers.push(fakeMarker);
    })
    return markers;
  }

  private _setMapServiceAreas(serviceAreas) {
    if (!this.filters.serviceAreas || !serviceAreas) {
      serviceAreas = [];
    }
    this.mapServiceAreas = this.mapsCommonService.buildPolygons(serviceAreas, true);
  }


}

angular
  .module('bringoz.admin.map')
  .component('fulfillmentMap', {
    bindings: {
      steps: '<?',
      attempts: '<?',
      serviceAreas: '<?'
    },
    template: require('./fulfillment-map.html').default,
    controller: FulfillmentMapComponent
  });
